import { MediaLightboxType } from './components'

export const mediaTypes = {
  [MediaLightboxType.IFRAME]: MediaLightboxType.VIDEO,
  [MediaLightboxType.VIDEO]: MediaLightboxType.VIDEO,
  [MediaLightboxType.IMAGE]: MediaLightboxType.IMAGE
}
